import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const AddWorkExperienceModal = ({ isOpen, onClose, onExperienceAdded }) => {
  const [formData, setFormData] = useState({
    companyName: '',
    jobTitle: '',
    startDate: '',
    endDate: '',
    isCurrentJob: false,
    description: '',
    location: '',
    achievements: ''
  });
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.companyName.trim() || !formData.jobTitle.trim()) {
      setError('Company name and job title are required');
      return;
    }
    setError('');
    onExperienceAdded(formData);
    onClose();
    setFormData({
      companyName: '',
      jobTitle: '',
      startDate: '',
      endDate: '',
      isCurrentJob: false,
      description: '',
      location: '',
      achievements: ''
    });
  };

  const handleClose = () => {
    setError('');
    onClose();
    setFormData({
      companyName: '',
      jobTitle: '',
      startDate: '',
      endDate: '',
      isCurrentJob: false,
      description: '',
      location: '',
      achievements: ''
    });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add Work Experience</h2>
          <button onClick={handleClose} className="modal-close">×</button>
        </div>
        <form onSubmit={handleSubmit} className="modal-body">
          {error && <div className="error-message">{error}</div>}
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Company Name *</label>
              <input type="text" value={formData.companyName} onChange={e => setFormData({...formData, companyName: e.target.value})} className="input-field" required />
            </div>
            <div className="form-group">
              <label className="form-label">Job Title *</label>
              <input type="text" value={formData.jobTitle} onChange={e => setFormData({...formData, jobTitle: e.target.value})} className="input-field" required />
            </div>
          </div>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Start Date *</label>
              <input type="date" value={formData.startDate} onChange={e => setFormData({...formData, startDate: e.target.value})} className="input-field" required />
            </div>
            <div className="form-group">
              <label className="form-label">End Date</label>
              <input type="date" value={formData.endDate} onChange={e => setFormData({...formData, endDate: e.target.value})} className="input-field" disabled={formData.isCurrentJob} />
            </div>
            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input type="checkbox" checked={formData.isCurrentJob} onChange={e => setFormData({...formData, isCurrentJob: e.target.checked})} className="checkbox-input" />
                <span className="checkbox-text">Current Job</span>
              </label>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Location</label>
            <input type="text" value={formData.location} onChange={e => setFormData({...formData, location: e.target.value})} className="input-field" />
          </div>
          <div className="form-group">
            <label className="form-label">Job Description</label>
            <ReactQuill value={formData.description} onChange={value => setFormData({...formData, description: value})} className="input-field quill-field" theme="snow" />
          </div>
          <div className="form-group">
            <label className="form-label">Key Achievements</label>
            <textarea value={formData.achievements} onChange={e => setFormData({...formData, achievements: e.target.value})} rows={3} className="input-field textarea-field" />
          </div>
          <div className="modal-actions">
            <button type="button" onClick={handleClose} className="btn btn-secondary">Cancel</button>
            <button type="submit" className="btn btn-primary">Add Experience</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddWorkExperienceModal; 